<template>
    <v-navigation-drawer v-model="drawer" clipped fixed app class="main-nav" style="z-index: 6 !important;">
        <v-list dense expand>
            <template v-for="(navItem, navIndex) in nav">
                <v-list-group
                    v-if="navItem.children"
                    :key="navIndex"
                    :prepend-icon="navItem.icon"
                    :value="containActiveNav(navItem, navItem.path)"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-title>{{ navItem.text }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <v-list-tile
                        v-for="(navSubItem, navSubIndex) in navItem.children"
                        :key="navSubIndex"
                        :class="comparePath(navSubItem)"
                        @click="redirectToPath(navSubItem)"
                    >
                        <v-list-tile-action v-if="navSubItem.icon">
                            <v-icon>{{ navSubItem.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{ navSubItem.text }}</v-list-tile-title>
                    </v-list-tile>
                </v-list-group>
                <a
                    v-else-if="navItem.external"
                    :key="navIndex"
                    :href="navItem.path"
                    target="_blank"
                    rel="noopener"
                >
                    <v-list-tile class="d-flex align-center">
                        <img :src="navItem.icon" alt="icon_menu" style="margin-right: 22px">
                        <v-list-tile-title>{{ navItem.text }}</v-list-tile-title>
                    </v-list-tile>
                </a>

                <!-- Internal link -->
                <router-link v-else :key="navIndex" :to="navItem.path">
                    <v-list-tile
                        :class="comparePath(navItem)"
                        class="d-flex align-center"
                    >
                        <img :src="navItem.icon" alt="icon_menu" style="margin-right: 22px">
                        <v-list-tile-title>{{ navItem.text }}</v-list-tile-title>
                    </v-list-tile>
                </router-link>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
import {mapState} from 'vuex'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import utils from "@/utils/utils";

export default {
    name: 'Navigation',
    mixins: [RoleMixin],
    data() {
        return {}
    },
    computed: {
        drawer: {
            get() {
                return this.$store.state.navigation
            },
            set(val) {
                this.$store.dispatch(this.$actionTypes.NAVIGATION, val)
            }
        },
        nav() {
            let navs = [
                {
                    text: this.$t('nav.user.dashboard'),
                    icon: '/img/dashboard.svg',
                    path: '/dashboard/'
                },
                {
                    text: this.$t('nav.admin.campaign'),
                    icon: '/img/campaign.svg',
                    path: '/campaign/'
                },
                {
                    text: this.$t('bot'),
                    icon: '/img/bot.svg',
                    path: '/scenarios/'
                }
            ]
            if (utils.enableTovaAgent()) {
                navs.push({
                    text: this.$t('tova'),
                    icon: '/img/agent.svg',
                    path: '/agents/'
                })
            }
            if (utils.enableVoiceAgent()) {
                navs.push({
                    text: this.$t('aiAgent'),
                    icon: '/img/agent-system.svg',
                    path: process.env.VUE_APP_AGENT_END_POINT,
                    external: true
                })
            }
            if (utils.enableQC()) {
                navs.push(
                    {
                        text: this.$t('nav.admin.qc'),
                        icon: '/img/qc.svg',
                        path: '/qc-campaign/'
                    })
            }

            for (let nav of navs) {
                nav.text = this.$filters.capitalize(nav.text)
            }
            return navs
        },
    },
    methods: {
        redirectToPath(navItem) {
            let path = navItem.path
            this.$router.push(path)
        },
        comparePath(item) {
            let cssClass = ''
            if (item.path && this.$route.path.includes(item.path)) {
                cssClass = 'active_navigation'
            } else if (item.aliasPath && this.$route.path.includes(item.aliasPath)) {
                cssClass = 'active_navigation'
            }
            return cssClass
        },
        containActiveNav(navItem, parentPath) {
            for (let item of navItem.children) {
                if (this.comparePath((item.path))) {
                    return true
                }
            }
            if (parentPath) {
                let windowPath = window.location.pathname
                if (windowPath.indexOf(parentPath) > -1) {
                    return true
                }
            }
            return false
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .v-list__tile {
        padding: 0 20px !important;
        border-bottom: 1px solid #E4EDFA;
    }
}

.active_navigation {
    border-radius: 4px;

    ::v-deep .v-list__tile__title {
        color: #0052CC !important;
        font-weight: 700 !important;
    }

    ::v-deep .v-list__tile {
        border-radius: 4px !important;
    }
}
</style>
